var _ForcProviderFooterComponent;
import Component from '@glimmer/component';
import perform from 'ember-concurrency/helpers/perform';
import ForcJournalEventBasedComponent from '../abstract/journal-event-based-component';
import CancelButton from './cancel-button';
import SubmitButton from './submit-button';
import { hash } from '@ember/helper';
import { WithBoundArgs as WBA } from '@glint/template';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class ForcProviderFooterComponent extends Component {
  get isSubmitButtonDisabled() {
    return this.args.forcComponent?.onSubmit.isRunning || this.args.forcComponent?.checkDirtyness && !this.args.forcComponent.isDirty;
  }
}
_ForcProviderFooterComponent = ForcProviderFooterComponent;
setComponentTemplate(precompileTemplate("\n    {{!-- prettier-ignore --}}\n    <div class=\"no-print\n        {{unless @smallFooter \"mt-[4em]\"}}\n        -mr-1 mb-0 flex justify-between\" ...attributes>\n      {{!-- @glint-expect-error We have 2 errors here. The first is on CancelButton because of the \"onClick\" argument and the perform helper. The second is because of a typo on \"isReadonly\". It should be \"isReadOnly\". The \"isReadonly\" typo makes the arg useless on SubmitButton and this arg should be removed--}}\n      {{yield (hash CancelButton=(component CancelButton disabled=@forcComponent.onSubmit.isRunning onClick=(perform @forcComponent.onCancel) title=@forcComponent.cancelButtonTitle) SubmitButton=(component SubmitButton disabled=this.isSubmitButtonDisabled isLoading=@forcComponent.onSubmit.isRunning title=@forcComponent.submitButtonTitle isReadOnly=@forcComponent.isReadonly))}}\n    </div>\n  ", {
  strictMode: true,
  scope: () => ({
    hash,
    CancelButton,
    perform,
    SubmitButton
  })
}), _ForcProviderFooterComponent);